var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:({ strokeWidth: _vm.strokeWidth }),attrs:{"viewBox":_vm.viewBox}},_vm._l((_vm.referenceImage.annotations),function(annotation,index){return _c('annotation-graphic',{key:index,attrs:{"annotation":annotation,"scale":_vm.scale}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }